/* eslint-disable */
'use strict';
import Splide from '@splidejs/splide';
import Zoomist from 'zoomist';

const ProductGallery = {
    modalZoomTrigger: '.js-zoom-image-modal-trigger',
    modalZoom: '.js-zoom-image-modal',
    modalZoomContent: '.js-zoom-image-modal-content',
    modalZoomWrapper: '.js-modal-zoom-wrapper',
    zoomPlusBtn: '.js-zoom-plus',
    zoomMinusBtn: '.js-zoom-minus',
    zoomLevel: 1,  // Default zoom level is 1 (scale 1)
    maxZoomLevel: 3, // Max zoom level (scale 2)
    minZoomLevel: 1, // Min zoom level (scale 1)
    zoomist: '.js-modal-zoom-zoomist', // Different zoom levels
    zoomistEl: null, 
    thumbnailSlider: null,
    zoomModalPdp: '.js-zoom-modal-pdp',
    imageSrc: '.js-zoomist-image-src',

    /**
     * Init function
     */
    init: function() {
        this.bindEvents();
        this.singleProductSlider();
        this.initZoomist();
        this.bindDesktopGridZoom();
    },

    initZoomist: function() {
        const zoomistEl = document.querySelector(this.zoomist);
        if (zoomistEl) {
            this.zoomistEl = new Zoomist(zoomistEl, {
                height: window.innerWidth > 575 ? 620 : 'auto',
                slider: false,
                zoomer: {
                    inEl: this.zoomPlusBtn,
                    outEl: this.zoomMinusBtn,
                },
                maxRatio: 3,
                zoomRatio: 0.3,
                wheelable: false,
                draggable: true,
                bounds: true,
                pinchable: true,
            });
        }
    },

    /**
     * Initializes the main product slider and thumbnail navigation slider.
     */
    singleProductSlider: function() {
        // Thumbnail navigation slider
        this.thumbnailSlider = new Splide('.js-modal-zoom__image-thumbnail-splide', {
            perPage: 5,
            perMove: 1,
            rewind: true,
            arrows: false,
            isNavigation: true,
            gap: 10,
            pagination: false,
            cover: false,
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            },
            breakpoints: {
                575: {
                    gap: 12,
                }
            },
        });

        // Sync main slider and thumbnail navigation slider
        this.thumbnailSlider.on('click', (e) => {
            this.updateZoomImage(e.slide);
        });
    
        this.thumbnailSlider.mount();
    },

    /**
     * Sets the active thumbnail from the zoom modal if `data-current-index` is present.
     */
    setActiveThumbnailFromZoomModal: function() {
        const thumbnailSlides = document.querySelectorAll('.js-modal-zoom__image-thumbnail-list');
        const zoomModalPdp = document.querySelector('.js-zoom-modal-pdp');
    
        if (zoomModalPdp && this.thumbnailSlider) {
            const currentIndex = zoomModalPdp.getAttribute('data-current-index');
            if (currentIndex) {
                const targetThumbnail = thumbnailSlides[currentIndex]; // Get the corresponding thumbnail
                if (targetThumbnail) {
                    this.thumbnailSlider.go(Number(currentIndex)); // Set the active slide to match the current index
                    this.updateZoomImage(targetThumbnail); // Update the zoom image based on the clicked thumbnail
                }
            }
        }
    },

    /**
     * Binds event listeners for zoom modal functionality
     */
    bindEvents: function() {
        const zoomTriggers = document.querySelectorAll(this.modalZoomTrigger);
        const modalZoom = document.querySelector(this.modalZoom);
    
        if (modalZoom) {
            zoomTriggers.forEach(trigger => {
                trigger.addEventListener('click', () => {
                    if (modalZoom.classList.contains('active')) {
                        if (this.zoomistEl) {
                            this.zoomistEl.destroy();
                        }
                        modalZoom.classList.remove('active');
                        document.body.classList.remove('zoom-open');
                    } else {
                        this.setActiveThumbnailFromZoomModal();
                        modalZoom.classList.add('active');
                        document.body.classList.add('zoom-open');
                    }
                });
            });
        }
    },

    /**
     * Binds click events on the desktop grid gallery images to open the zoom modal
     * at the correct image index.
     */
    bindDesktopGridZoom: function() {
        const gridItems = document.querySelectorAll('.js-pdp-gallery-zoom');
        const modalZoom = document.querySelector(this.modalZoom);

        if (!gridItems.length || !modalZoom) return;

        gridItems.forEach(item => {
            const handler = () => {
                const index = parseInt(item.getAttribute('data-gallery-index') || '0', 10);
                const thumbnailSlides = document.querySelectorAll('.js-modal-zoom__image-thumbnail-list');
                const targetThumbnail = thumbnailSlides[index];

                if (!this.zoomistEl) {
                this.initZoomist();
                }

                if (targetThumbnail) {
                this.thumbnailSlider.go(index);
                this.updateZoomImage(targetThumbnail);
                }

                modalZoom.classList.add('active');
                document.body.classList.add('zoom-open');
            };

            item.addEventListener('click', handler);

            item.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handler();
                setTimeout(() => {
                    document.querySelector('.product-single__zoom-modal-close').focus(); 
                }, 100);
                }
            });
        });
    },

    /**
     * Update the zoom image when a thumbnail is clicked
     * @param {HTMLElement} target - The clicked thumbnail
     */
    updateZoomImage: function(target) {
        const imageSrc = target.querySelector('img').getAttribute('src');
        const cleanedImageSrc = imageSrc.replace(/([&?])(width=\d+)/g, '&width=2000');
        const zoomistDivEl = document.querySelector('.js-zoomist-image-src');
        zoomistDivEl.setAttribute('src', cleanedImageSrc);
        zoomistDivEl.setAttribute('srcset', cleanedImageSrc);

        if (this.zoomistEl) {
            this.zoomistEl.update();
        }
    }
};

export default ProductGallery;
